<div class="d-flex flex-column h-100">
    <!-- PM Edit Bar -->
    <publish-bar 
        *ngIf="!iscxonedashboard"
        [hidden]="!publishPending || isSharedURL" 
        class="w-100"
        [type]="'publish'"
        (save)="publishChanges();"
        (discard)="discardChanges();"></publish-bar>

    <!-- PM Template Save to Dashboards -->
    <publish-bar
        *ngIf="!iscxonedashboard"
        [hidden]="!temporaryDashboardPending || isSharedURL"
        class="w-100"
        [type]="'template'"
        (save)="saveTemporaryDashboard();"
        (discard)="discardTemporaryDashboard();"></publish-bar>

    <!-- CXOne Edit Bar-->
    <div *ngIf="iscxonedashboard && editPending && !temporaryDashboardPending" class="cxone-edit-bar" [class.cxone-header-index]="navigationService.showOverlay">
        <div style="width: 100%; height: 100%; display: flex; align-items: center; padding-left: 30px;">
            <span cvLocalizedText [langSection]="'Common'" [langKey]="'Edit'">Edit</span> <span>&nbsp;{{service.getActiveDashboard().DashboardName}}</span>
        </div>
        <div style="align-self: end; display: flex; align-items: center;
        justify-content: flex-end; height: 60px; width: 100%; padding-right: 30px; gap: 10px;">
            <ng-template #leaveEditContent>
                <div class="pb-2">
                    <div class="popoverText popoverSpacingTop" style="padding-bottom: 3px;" cvLocalizedText langSection="CXOne_Dashboard" langKey="Lose_Changes">All changes will be lost.</div>
                    <div class="popoverText popoverSpacingBottom" cvLocalizedText langSection="CXOne_Dashboard" langKey="Discard_Changes">Are you sure you want to discard your changes?</div>
                    <div class="d-flex confirmBtns" style="margin-left: 16px;">
                        <button type="button" (click)="p.close()" class="cxone-btn btn-medium btn-popover" style="margin-right: 10px;">
                            <span cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'No'">No</span>
                        </button>
                        <button type="button" (click)="discardChanges()" class="cxone-btn btn-medium btn-primary">
                            <span cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Yes'">Yes</span>
                        </button>
                    </div>
                </div>
            </ng-template>
            <button id="addModulesButton" type="button" class="cxone-btn btn-secondary" [ngbPopover]="leaveEditContent" popoverClass="cxoneHeaderPopover" triggers="manual" #p="ngbPopover" (click)="p.open()"
                    style="height: 36px; min-width: 90px; opacity: 1; color: #697782; margin-top: -1px;">
                <span cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'">Cancel</span>
            </button>
            <button class="cxone-btn btn-primary" style="height: 36px; min-width: 90px; margin-top: -1px;" type="button" [ngbPopover]="navigationService.addingModule ? waitWidgetTooltip : navigationService.applyingFilters ? applyingFiltersTooltip : ''" triggers="mouseenter:mouseleave" placement="left" container="body" popoverClass="headerMenuTooltip" (click)="publishChanges()" [disabled]="navigationService.addingModule || navigationService.applyingFilters">
                <span cvLocalizedText [langSection]="'Common'" [langKey]="'Save_Button'">Save</span>
            </button>
        </div>
    </div>

    <!-- CXOne Template Edit Bar -->
    <div *ngIf="iscxonedashboard && editPending && temporaryDashboardPending" class="cxone-edit-bar" [class.cxone-header-index]="navigationService.showOverlay">
        <div style="width: 100%; height: 100%; display: flex; align-items: center; padding-left: 30px;">
            <span cvLocalizedText [langSection]="'Common'" [langKey]="'Edit'">Edit</span> <span>&nbsp;{{service.getActiveDashboard().DashboardName}}</span>
        </div>
        <div style="align-self: end; display: flex; align-items: center;
        justify-content: flex-end; height: 60px; width: 100%; padding-right: 30px; gap: 10px;">
            <ng-template #leaveEditContent>
                <div class="pb-2">
                    <div class="popoverText popoverSpacingTop" style="padding-bottom: 3px;" cvLocalizedText langSection="CXOne_Dashboard" langKey="Lose_Changes">All changes will be lost.</div>
                    <div class="popoverText popoverSpacingBottom" cvLocalizedText langSection="CXOne_Dashboard" langKey="Discard_Changes">Are you sure you want to discard your changes?</div>
                    <div class="d-flex confirmBtns" style="margin-left: 16px;">
                        <button type="button" (click)="p.close()" class="cxone-btn btn-medium btn-popover" style="margin-right: 10px;">
                            <span cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'No'">No</span>
                        </button>
                        <button type="button" (click)="discardChanges()" class="cxone-btn btn-medium btn-primary">
                            <span cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Yes'">Yes</span>
                        </button>
                    </div>
                </div>
            </ng-template>
            <button id="addModulesButton" type="button" class="cxone-btn btn-secondary" [ngbPopover]="leaveEditContent" popoverClass="cxoneHeaderPopover" triggers="manual" #p="ngbPopover" (click)="p.open()"
                    style="height: 36px; min-width: 90px; opacity: 1; color: #697782; margin-top: -1px;">
                <span cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'">Cancel</span>
            </button>
            <button class="cxone-btn btn-primary" style="height: 36px; min-width: 120px; margin-top: -1px;" type="button" (click)="saveCXOneTemplateChanges()">
                <span cvLocalizedText [langSection]="'Common'" [langKey]="'Save_As_Draft'">Save as a Draft</span>
            </button>
        </div>
    </div>

    <cv-dashboard-header #dashboardHeader  *ngIf="navigationService.isResponsiveDashboard && iscxonedashboard && !dashboardManager.isDashboardProjection" 
        [publishPending]="publishPending" [class.cxone-header-index]="navigationService.showOverlay" (addingWidget)="toggleAddingWidget()" 
        [isAddingWidgets]="addingWidget" [modules]="modules" [dashboardManager]="dashboardManager"
    ></cv-dashboard-header>

    <div class="grid-background flex-fill"
         [class.has-taskbar]="service.taskbarModules.length > 0 && !states.dashboardModules.loading && !dashboardManager.isShared"
         [class.mb-3]="iscxonedashboard"
         [class.publish-pending]="publishPending || temporaryDashboardPending"
         [class.fullscreen]="isFullscreen"
         [class.grid-background-padding]="iscxonedashboard"
         [class.viaBrowser]="service.isDashboardWindow"
         [style.height]="iscxonedashboard ?? 'auto'"
         (drop)="onDrop($event)"
         (dragover)="dragOver($event)"
         (dragenter)="dragEnter($event)"
         (dragleave)="dragLeave($event)"
         cvNavigationSidebarClass
         #gridBackground>
        <cv-loader [overlay]="true" size="large" *ngIf="showLoader" [loaderType]="iscxonedashboard ? 'cxone' : 'clearview'" [cxoneIsSpinner]="false"></cv-loader>

        <div id="fullscreenToggle" [hidden]="navigationService.showOverlay || iscxonedashboard" [class.viaBrowser]="service.isDashboardWindow" class="fullscreen-toggle">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" [hidden]="isFullscreen" (click)="toggleFullscreen()">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/expand.svg#expand"></use>
                </svg>
            </button>
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" [hidden]="!isFullscreen" (click)="toggleFullscreen()">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/shrink.svg#shrink"></use>
                </svg>
            </button>
        </div>

        <div class="grid-no-modules" *ngIf="!showLoader && !modules?.length && !iscxonedashboard">
            <div class="grid-no-modules-message" *ngIf="dashboardManager.writeAccess" cvLocalizedText langSection="Module_Menu" langKey="No_Modules_Message">Click or drag modules from the left to add them to your dashboard.</div>
            <div class="grid-no-modules-message" *ngIf="!dashboardManager.writeAccess" cvLocalizedText langSection="Module_Menu" langKey="No_Widgets_Added">No widgets have been added to this dashboard.</div>
        </div>

        <div class="cxone-grid-no-modules" *ngIf="!showLoader && !modules?.length && iscxonedashboard">
            <div class="cxone-grid-no-modules-message" cvLocalizedText langSection="CXOne_Dashboard" langKey="No_Widgets_Message">Click a widget Or drag here</div>
        </div>

        <gridster id="gridster" [ngClass]="publishPending ? 'grid-canvas-publish' : 'grid-canvas'" [class.grid-canvas-cxone]="iscxonedashboard"
                  [hidden]="showLoader || modules?.length === 0" [options]="gridsterOptions" #gridCanvas>
            <gridster-item [class.focused]="item.moduleKey && focusedModuleKey === item.moduleKey" [class.projection]="service.isDashboardProjection"
                [item]="item" *ngFor="let item of this.modules">
                <div [ngClass]="item.isPlaceholder === true ? 'grid-item-placeholder gridster-item-moving' : 'gridItem'">
                    <cv-module-container *ngIf="!item.isPlaceholder"
                                         [dashboardManager]="dashboardManager"
                                         [module]="item"
                                         [moduleId]="item.ModuleID"
                                         [mkey]="item.moduleKey"
                                         [publishBar]="iscxonedashboard">
                    </cv-module-container>
                </div>
            </gridster-item>
        </gridster>

        <!-- PM counter -->
        <div class="module-count color-inversion shadow position-fixed px-3 py-1 d-flex flex-row justify-content-start"
             *ngIf="!navigationService.showOverlay && !iscxonedashboard"
             [class.has-taskbar]="service.taskbarModules.length > 0">
            <div class="module-count-label d-flex flex-row">
                <span cvLocalizedText langSection="CXOne_Dashboard" langKey="Widgets">Widgets</span>
                <span>:</span>
            </div>
            {{ modules?.length ?? 0 }} / {{ service.MAX_MODULES }}
        </div>
        <!-- CXOne counter -->
        <div class="module-count color-inversion shadow position-fixed px-3 py-1 d-flex flex-row justify-content-start"
             *ngIf="iscxonedashboard"
             [class.has-taskbar]="service.taskbarModules.length > 0">
            <div class="module-count-label d-flex flex-row">
                <span cvLocalizedText langSection="CXOne_Dashboard" langKey="Widgets">Widgets</span>
                <span>:</span>
            </div>
            {{ modules?.length ?? 0 }} / {{ service.MAX_MODULES }}
        </div>
    </div>
</div>
